import {Component, OnDestroy} from '@angular/core';
import {TabItemModel} from '../../../../models/tab-item-model';
import {ShareService} from "../../../../services/share.service";
import {Subscription} from "rxjs";
import {ValidationService} from "../../../../services/validation.service";

@Component({
  selector: 'app-install-sensors',
  templateUrl: './install-sensors.component.html',
  styleUrls: ['./install-sensors.component.scss'],

})
export class InstallSensorsComponent implements OnDestroy {
  public tabs: TabItemModel[] = [
    {id: 0, label: 'Temperatur', route: 'temperature', isDisabled: false, isVisible: true, isInvalid: false},
    {id: 1, label: 'Pumpen', route: 'pump', isDisabled: false, isVisible: true, isInvalid: false},
    {id: 2, label: 'Zähler', route: 'counter', isDisabled: false, isVisible: true, isInvalid: false},
    {
      id: 3,
      label: 'Steuerung',
      route: 'control',
      isDisabled: false,
      isVisible: true,
      isInvalid: false
    },
    {id: 4, label: 'Sonstige', route: 'other', isDisabled: false, isVisible: true, isInvalid: false}
  ];

  private subscriptions: Subscription[] = [];

  constructor(
    private shareService: ShareService,
    private validationService: ValidationService,
  ) {
    this.subscriptions.push(this.shareService.sensorsTemperature$.subscribe(model => this.tabs[0].isInvalid = !this.validationService.isSensorsTemperatureValid(model)));
    this.subscriptions.push(this.shareService.sensorsPump$.subscribe(model => this.tabs[1].isInvalid = !this.validationService.isSensorsPumpValid(model)));
    this.subscriptions.push(this.shareService.sensorsCounter$.subscribe(model => this.tabs[2].isInvalid = !this.validationService.isSensorsCounterValid(model)));
    this.subscriptions.push(this.shareService.sensorsOutsideTemp$.subscribe(model => this.tabs[3].isInvalid = !this.validationService.isSensorsControlValid(model)));
    this.subscriptions.push(this.shareService.sensorsOther$.subscribe(model => this.tabs[4].isInvalid = !this.validationService.isSensorsOtherValid(model)));
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
